import { render, staticRenderFns } from "./EditRecordRight.vue?vue&type=template&id=dc0a668a&scoped=true"
import script from "./EditRecordRight.vue?vue&type=script&lang=js"
export * from "./EditRecordRight.vue?vue&type=script&lang=js"
import style0 from "./EditRecordRight.vue?vue&type=style&index=0&id=dc0a668a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0a668a",
  null
  
)

export default component.exports